module.exports = __webpack_public_path__ + "static/media/new-customer-number.beae2d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-customer-number.png
// module id = 1648
// module chunks = 0